var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6141 2.86723L16.3713 11.9882L13.6375 14.6872C12.34 15.9692 10.5908 16.6872 8.76656 16.6872H5.12512C3.39886 16.6872 2.00043 18.0862 2.00043 19.8122V32.4652C2.00043 34.1912 3.39886 35.5942 5.12512 35.5942H8.76656C10.5908 35.5942 12.34 36.3092 13.6375 37.5902L16.3713 40.2892L23.6141 49.4142C25.5043 51.2812 29.7075 49.9412 29.7075 47.2812V4.99622C29.7075 2.34023 25.5043 1.00023 23.6141 2.86723Z",
    fill: "#0068FF",
    stroke: "#0068FF",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3837 15.4222C38.9496 18.2542 40.5159 22.0162 40.5159 26.1412C40.5159 30.2662 38.9496 34.0232 36.3837 36.8552",
    stroke: "#0068FF",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4695 6.61722C46.5673 11.5592 49.7389 18.4802 49.7389 26.1412C49.7389 33.8012 46.5673 40.7232 41.4695 45.6602",
    stroke: "#0068FF",
    strokeWidth: 4.00086,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.200cfa4f76a876cfa9b2c0aa08841fd9.svg";
export { ForwardRef as ReactComponent };